import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_myTheme from "../../theme/am4themes_myTheme";
import { useRef, useLayoutEffect, useState, useEffect } from 'react'
import colors from '../../theme/colors'
// import time from '../../utils/time'
am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_myTheme);

const styles = {
    chartDiv: (orientation, hasLegend) => ({
        width: "100%",
        height: (orientation == 'vertical') ?
            hasLegend ?
                450 :
                475 :
            750
    })
}

const setColumnColors = ({ key, series }) => {
    // console.log(key)
    if (key.includes('positive')) {
        series.columns.template.fill = colors.POSITIVE
        series.columns.template.stroke = colors.POSITIVE
    } else if (key.includes('neutral')) {
        series.columns.template.fill = colors.NEUTRAL
        series.columns.template.stroke = colors.NEUTRAL
    } else if (key.includes('negative')) {
        series.columns.template.fill = colors.NEGATIVE
        series.columns.template.stroke = colors.NEGATIVE
    } else if (key.includes('Stories')) {
        series.columns.template.fill = colors.DEFAULT_LINE
        series.columns.template.stroke = colors.DEFAULT_LINE
    }
    else {
        series.columns.template.fill = colors.DEFAULT_BAR
        series.columns.template.stroke = colors.DEFAULT_BAR
    }

    return series
}

const setBulletText = ({ bullet, orientation, total, showPercent }) => {
    let valueAlpha
    let differential, positionValue
    switch (orientation) {
        case 'horizontal':
            valueAlpha = 'valueX'
            differential = 'dx'
            positionValue = 10
            break
        case 'vertical':
            valueAlpha = 'valueY'
            differential = 'dy'
            positionValue = -5
            break
    }
    bullet.interactionsEnabled = false;
    bullet.label.text = `{${valueAlpha}}`
    bullet.label.fill = am4core.color("#000000");
    bullet.label[differential] = positionValue

    return bullet
}

const setSeries = ({ series, orientation, sItem, total, showPercent, categoryAxis }) => {
    let valueShow, categoryAlpha, valueAlpha, alphaAxis
    switch (orientation) {
        case 'horizontal':
            valueShow = 'valueXShow'
            categoryAlpha = 'categoryY'
            valueAlpha = 'valueX'
            alphaAxis = 'yAxis'
            break;
        case 'vertical':
            valueShow = 'valueYShow'
            categoryAlpha = 'categoryX'
            valueAlpha = 'valueY'
            alphaAxis = 'xAxis'
            break;
    }

    series.columns.template.width = am4core.percent(50);
    series.name = sItem.title || sItem.key;
    series.tooltip.pointerOrientation = "vertical";

    if (total) series.dataFields[valueShow] = "totalPercent";
    series.dataFields[categoryAlpha] = "x";
    series.dataFields[valueAlpha] = sItem.key;
    series[alphaAxis] = categoryAxis;

    let textToShow = total !== undefined
        ? `{${valueAlpha}.totalPercent.formatNumber('#.')}%`
        : showPercent !== undefined
            ? `{${valueAlpha}.percent.formatNumber('#.')}%`
            : `{${valueAlpha}.formatNumber('#.')}`;

    series.columns.template.tooltipText = "{name}: " + textToShow;
    series.dataItems.template.locations[categoryAlpha] = 0.5;
    series = setColumnColors({ series, key: sItem.key })
    return series
}

function AmBarChart({ resultSet, amchartId, orientation, total, showPercent, mirror, hasLegend }) {
    const chart = useRef(null);
    useLayoutEffect(() => {

        let wrapOrTruncate = orientation == 'vertical' ? 'wrap' : 'truncate'
        let x = am4core.create(`chartdiv-bar-${resultSet.seriesNames()[0]/* .title */}-${amchartId}`, am4charts.XYChart);

        x.padding(30, 30, 10, 30);

        let categoryAxis
        if (orientation === "vertical") {
            categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
        } else {
            categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
        }
        categoryAxis.dataFields.category = "x";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 10;
        categoryAxis.renderer.cellStartLocation = 0.15
        categoryAxis.renderer.cellEndLocation = 0.85

        categoryAxis.renderer.labels.template.wrap = orientation == 'vertical' ? true : false
        // categoryAxis.renderer.labels.template[wrapOrTruncate] = true
        categoryAxis.renderer.labels.template.maxWidth = 110

        let valueAxis;
        if (orientation === "vertical") {
            valueAxis = x.yAxes.push(new am4charts.ValueAxis());
        } else {
            valueAxis = x.xAxes.push(new am4charts.ValueAxis());
        }
        valueAxis.calculateTotals = true;
        valueAxis.renderer.minWidth = 50;

        const cornerRadius = (radius, item) => {
            let dataItem = item.dataItem;

            let lastSeries;
            x.series.each((series) => {
                if (dataItem.dataContext[series.dataFields.valueY] && !series.isHidden && !series.isHiding) {
                    lastSeries = series;
                }
            });
            return dataItem.component == lastSeries ? 10 : radius;
        }


        resultSet.seriesNames().map(sItem => {
            let series = x.series.push(new am4charts.ColumnSeries());

            var bullet = series.bullets.push(new am4charts.LabelBullet());

            series = setSeries({ series: series, orientation, sItem, total, showPercent, categoryAxis })
            bullet = setBulletText({ bullet, orientation, total, showPercent })
        })

        // x.scrollbarX = new am4core.Scrollbar();
        // x.scrollbarY = new am4core.Scrollbar();

        x.cursor = new am4charts.XYCursor();
        // x.data = orientation == 'vertical' ? time.formatTimeStrings(resultSet.chartPivot()) : time.formatTimeStrings(resultSet.chartPivot().reverse())
        x.data = orientation == 'vertical' ? resultSet.chartPivot() : resultSet.chartPivot().reverse()
        // And, for a good measure, let's add a legend
        if (hasLegend) x.legend = new am4charts.Legend();

        x.logo.disabled = true

        chart.current = x;

        return () => {
            x.dispose();
        };
    }, []);

    return (
        <div id={`chartdiv-bar-${resultSet.seriesNames()[0]/*  */}-${amchartId}`} style={styles.chartDiv(orientation, hasLegend)}></div>
    );
}

export default AmBarChart;